const iosMessageHandlers = window?.webkit?.messageHandlers;

const mobileBus =
  iosMessageHandlers?.tabbyMobileSDK ||
  window?.tabbyMobileSDK ||
  iosMessageHandlers?.ReactNativeWebView ||
  window?.ReactNativeWebView;

export const isMobileAppContext = !!mobileBus;
